module.exports = __webpack_public_path__ + "newstatic/img/two-a.0cc1797.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/two-a.png
// module id = 4+Md
// module chunks = 1